import Brand from './brands/Brand';
import EdroBrand from './brands/EdroBrand';
import { CPSConfigAlarm, CPSConfigCard, IProduct } from './products/IProduct';
import { P00039 } from './products/edro/P00039';
import { P00030 } from './products/edro/P00030';
import { P00031 } from './products/edro/P00031';
import { P00032 } from './products/edro/P00032';
import { P00037 } from './products/edro/P00037';
import { P00041 } from './products/edro/P00041';
import { P00042 } from './products/edro/P00042';
import { P00043 } from './products/edro/P00043';
import { P00045 } from './products/edro/P00045';
import { P00046 } from './products/edro/P00046';
import { P00049 } from './products/edro/P00049';
import { P0003600 } from './products/edro/P0003600';
import { P0003601 } from './products/edro/P0003601';
import { P0003602 } from './products/edro/P0003602';
import { P0003603 } from './products/edro/P0003603';
import { P0003604 } from './products/edro/P0003604';
import { P0003605 } from './products/edro/P0003605';
import { P0003606 } from './products/edro/P0003606';
import { P0003607 } from './products/edro/P0003607';
import { P0004700 } from './products/edro/P0004700';
import { P0004702 } from './products/edro/P0004702';
import { P0004703 } from './products/edro/P0004703';
import { P0004704 } from './products/edro/P0004704';
import { P0004800 } from './products/edro/P0004800';
import { P0004801 } from './products/edro/P0004801';
import { IMaster } from './products/IMaster';
import { P00061 } from './products/edro/P00061';
import { P00058 } from './products/edro/P00058';
import { P00062 } from './products/edro/P00062';
import { P0006600 } from './products/edro/P0006600';
import { UserContextService } from '../user-context.service';
import { Pool } from '../../apis/pool.api';
import { FirmwareApi } from '../../apis/productFirmware.api';
import { LabelConfigurationWarningMode } from './helper/enum/LabelConfigurationType';
import { User } from '../../apis/profil.api';
import { TranslateService } from '@ngx-translate/core';
import { P00077 } from './products/europiscine/P00077';
import EuropiscineBrand from './brands/EuropiscineBrand';
import { EdroNetworkManager } from './manager/edro-network-manager';
import { AppComponent } from '../../app.component';
import { Company } from '../../apis/company.api';
import { P00080 } from './products/edro/P00080';
import { P00076 } from './products/edro/P00076';

export function getAllBrands(): any {
  let res = [];

  res.push({ ref: 'edro', label: 'brand.edro', brand: new EdroBrand() });
  res.push({
    ref: 'driveo',
    label: 'brand.driveo',
    brand: new EuropiscineBrand(),
  });

  return res;
}

export function setBrandByPool(p: Pool): any {
  const b = getBrandByModelIdentifier(p.deviceTable.master.modelIdentifier);
  AppComponent.currentBrand = b;
}

export function setBrandByOrganisation(o: Company | null | undefined): any {
  if (o && (o.type === 'europiscine' || o.parent?.type === 'europiscine')) {
    AppComponent.currentBrand = new EuropiscineBrand();
    return;
  }

  AppComponent.currentBrand = new EdroBrand();
}

export function getBrandByQRCode(
  modelIdentifier: string | null | undefined,
): Brand | null {
  if (modelIdentifier === null || modelIdentifier === undefined) {
    return null;
  }

  let brand = new EdroBrand();
  switch (modelIdentifier) {
    case 'P00039':
      brand = new EdroBrand();
      break;
    case 'P00077':
      brand = new EuropiscineBrand();
      break;
    default:
      return null;
  }

  return brand;
}

export function getBrandByModelIdentifier(
  modelIdentifier: string | null | undefined,
): Brand {
  if (modelIdentifier === null || modelIdentifier === undefined) {
    return new EdroBrand();
  }

  let brand = new EdroBrand();
  switch (modelIdentifier) {
    case 'P00039':
      brand = new EdroBrand();
      break;
    case 'P00077':
      brand = new EuropiscineBrand();
      break;
  }

  return brand;
}

export function isMaster(product: IProduct): boolean {
  switch (product.modelIdentifier) {
    case 'P00039':
      return true;
    case 'P00077':
      return true;
  }

  return false;
}

export function isConnect(product: IProduct): boolean {
  switch (product.modelIdentifier) {
    case 'P00045':
      return true;
  }

  return false;
}

export function getProductByModelIdentifier(
  modelIdentifier: string | null | undefined,
  removeTiret = false,
): IProduct | null {
  switch (modelIdentifier) {
    case 'P00030':
      return new P00030();
    case 'P00031':
      return new P00031();
    case 'P00032':
      return new P00032();
    case 'P00037' + (removeTiret ? '' : '-') + '00':
      return new P00037();
    case 'P00039':
      return new P00039();
    case 'P00077':
      return new P00077();
    case 'P00041':
      return new P00041();
    case 'P00042':
      return new P00042();
    case 'P00043':
      return new P00043();
    case 'P00045':
      return new P00045();
    case 'P00046':
      return new P00046();
    case 'P00049':
      return new P00049();
    case 'P00061':
      return new P00061();
    case 'P00062':
      return new P00062();
    case 'P00058':
      return new P00058();
    case 'P00080':
      return new P00080();
    case 'P00076':
      return new P00076();

    case 'P00036' + (removeTiret ? '' : '-') + '00':
      return new P0003600();
    case 'P00036' + (removeTiret ? '' : '-') + '01':
      return new P0003601();
    case 'P00036' + (removeTiret ? '' : '-') + '02':
      return new P0003602();
    case 'P00036' + (removeTiret ? '' : '-') + '03':
      return new P0003603();
    case 'P00036' + (removeTiret ? '' : '-') + '04':
      return new P0003604();
    case 'P00036' + (removeTiret ? '' : '-') + '05':
      return new P0003605();
    case 'P00036' + (removeTiret ? '' : '-') + '06':
      return new P0003606();
    case 'P00036' + (removeTiret ? '' : '-') + '07':
      return new P0003607();

    case 'P00047' + (removeTiret ? '' : '-') + '00':
      return new P0004700();
    case 'P00047' + (removeTiret ? '' : '-') + '02':
      return new P0004702();
    case 'P00047' + (removeTiret ? '' : '-') + '03':
      return new P0004703();
    case 'P00047' + (removeTiret ? '' : '-') + '04':
      return new P0004704();

    case 'P00048' + (removeTiret ? '' : '-') + '00':
      return new P0004800();
    case 'P00048' + (removeTiret ? '' : '-') + '01':
      return new P0004801();

    case 'P00066' + (removeTiret ? '' : '-') + '00':
      return new P0006600();
  }

  return null;
}

export function getDataValue(
  value: any,
  unitPost: string | null = null,
  defaultValue: any = '--',
) {
  if (value === undefined || value === null) {
    return defaultValue;
  }

  return value + (unitPost ? ' ' + unitPost : '');
}

export function getMinutesValue(
  value: any,
  translate: TranslateService,
  defaultValue: any = '--',
) {
  if (value === undefined || value === null) {
    return defaultValue;
  }

  let jour = Math.floor(value / 1440);
  let hour = Math.floor((value - jour * 1440) / 60);
  let minut = Math.floor(value - jour * 1440 - hour * 60);

  let res = [];

  if (jour > 0) {
    res.push(jour + translate.instant('time.day'));
  }

  if (hour > 0) {
    res.push(hour + translate.instant('time.hour'));
  }

  if (minut >= 0) {
    res.push(minut + translate.instant('time.minut'));
  }

  return res.join(' ');
}

export function getSecondesValue(
  value: any,
  translate: any,
  defaultValue: any = '--',
) {
  if (value === undefined || value === null) {
    return defaultValue;
  }

  let jour = Math.floor(value / 86400);
  let hour = Math.floor((value - jour * 86400) / 3600);
  let minut = Math.floor((value - jour * 86400 - hour * 3600) / 60);
  let second = Math.floor(value - jour * 86400 - hour * 3600 - minut * 60);

  let res = [];

  if (jour > 0) {
    res.push(jour + translate('time.day'));
  }

  if (hour > 0) {
    res.push(hour + translate('time.hour'));
  }

  if (minut > 0) {
    res.push(minut + translate('time.minut'));
  }

  if (second >= 0) {
    res.push(second + translate('time.seconde'));
  }

  return res.join(' ');
}

export function getDataValueFromList(
  value: any,
  list: any,
  defaultValue: any = '--',
) {
  if (value === undefined || value === null) {
    return defaultValue;
  }

  for (let i = 0; i < list.length; i++) {
    if (list[i].ref == value) {
      return list[i].label;
    }
  }

  return defaultValue;
}

export function getPoolProducts(pool: Pool | null | undefined): IProduct[] {
  if (
    pool &&
    pool.deviceTable &&
    pool.deviceTable.master &&
    pool.deviceTable.master.deviceTable
  ) {
    const products: IProduct[] = [];

    Object.keys(pool.deviceTable.master.deviceTable).forEach((key) => {
      try {
        if (pool.deviceTable.master.deviceTable[key].presenceProduit > 0) {
          let p = getProductByModelIdentifier(key, true);
          if (p) {
            products.push(pool!.deviceTable[p!.dataIdentifier!]);
          }
        }
      } catch (e) {
        console.log(e);
      }
    });

    return products;
  }

  return [];
}

export function getPoolProductsWithCloudHash(
  pool: Pool,
  poolContextData: any,
): string {
  if (
    pool &&
    pool.deviceTable &&
    pool.deviceTable.master &&
    pool.deviceTable.master.deviceTable
  ) {
    let str =
      poolContextData.networkState.mqttState +
      '_' +
      poolContextData.networkState.bleState;

    const poolProducts = getPoolProducts(pool);

    for (let j = 0; j < poolProducts.length; j++) {
      let product = poolProducts[j];

      if (product) {
        let p: any = getProductByModelIdentifier(
          product.modelIdentifier,
          false,
        );
        const dt = p.getProductDeviceTableFromPool(pool);
        str +=
          p.modelIdentifier + '_' + dt.firmwareVersion + '_' + dt.gblVersion;
      }
    }

    return str;
  }

  return '';
}

export function isSupportTechnique(userData: User | null = null): boolean {
  if (userData == null) {
    userData = UserContextService.staticCurrentUser;
  }

  if (userData?.roles?.includes('ROLE_SUPPORT')) {
    return true;
  }

  return false;
}

export function getPoolConnectClass(pool: Pool): IProduct | null {
  const products = getPoolProducts(pool);

  for (let i = 0; i < products.length; i++) {
    if (isConnect(products[i])) {
      return getProductByModelIdentifier(products[i].modelIdentifier);
    }
  }

  return null;
}

export function getPoolMaster(pool: Pool | null | undefined): IMaster | null {
  if (pool && pool.deviceTable) {
    let res = null;
    Object.keys(pool.deviceTable).forEach((key) => {
      if (
        typeof pool!.deviceTable[key] == 'object' &&
        'modelIdentifier' in pool!.deviceTable[key] &&
        isMaster(pool!.deviceTable[key])
      ) {
        res = pool!.deviceTable[key];
      }
    });

    return res;
  }

  return null;
}

export async function getPoolProductsWithCloudUpdate(
  pool: Pool,
  firmwareApi: FirmwareApi,
): Promise<IProduct[]> {
  if (
    pool &&
    pool.deviceTable &&
    pool.deviceTable.master &&
    pool.deviceTable.master.deviceTable
  ) {
    const products: IProduct[] = [];

    //Si il y a connect, on ne regarde pas dans le cloud
    const hasConnect = getPoolConnectClass(pool) != null;

    const firmwares = pool.id
      ? ((await firmwareApi.getFirmwareByPoolId(pool.id!)) as any)
      : null;

    const poolProducts = getPoolProducts(pool);

    for (let j = 0; j < poolProducts.length; j++) {
      let product = poolProducts[j];

      if (product) {
        let p: any = getProductByModelIdentifier(
          product.modelIdentifier,
          false,
        );
        const dt = p.getProductDeviceTableFromPool(pool);

        for (let i = 0; i < firmwares.length; i++) {
          if (p.modelIdentifier === firmwares[i].modelIdentifier) {
            if (hasConnect) {
              if (
                dt.gblVersion != 0 &&
                dt.gblVersion != dt.firmwareVersion &&
                dt.gblVersion == firmwares[i].firmwareVersion
              ) {
                products.push(p);
              }
            }
          }
        }
      }
    }

    return products;
  }

  return [];
}

export function getPoolProductsClass(
  pool: Pool | null | undefined,
): IProduct[] {
  if (pool && pool.deviceTable) {
    const products: IProduct[] = [];

    Object.keys(pool.deviceTable.master.deviceTable).forEach((key) => {
      try {
        let p = getProductByModelIdentifier(key, true);

        if (p) {
          products.push(p);
        }
      } catch (e) {
        console.log(e);
      }
    });

    return products;
  }

  return [];
}

export function getAllFunctionality(pool: Pool, t: TranslateService): any[] {
  const products = getPoolProductsClass(pool);

  const productsFunctionnalities = [];
  const itemsMonth: any[] = [];

  for (let i = 0; i < products.length; i++) {
    if (new P00039().hasProduct(pool, products[i]) > 0) {
      const fn = products[i].getEventProductFunctionalities();

      for (let j = 0; j < fn.length; j++) {
        if (productsFunctionnalities.indexOf(fn[j]) == -1) {
          productsFunctionnalities.push(fn[j]);
        }
      }
    }
  }

  for (let i = 0; i < productsFunctionnalities.length; i++) {
    itemsMonth.push({
      label: t.instant('functionality.' + productsFunctionnalities[i]),
      ref: productsFunctionnalities[i],
    });
  }

  itemsMonth.sort(function (a, b) {
    if (a.label < b.label) {
      return -1;
    }
    if (a.label > b.label) {
      return 1;
    }
    return 0;
  });

  return [...itemsMonth];
}

function weightSort(a: CPSConfigCard, b: CPSConfigCard) {
  if (a.weight < b.weight) {
    return -1;
  }
  if (a.weight > b.weight) {
    return 1;
  }
  return 0;
}

export function getPoolGraphiquesConfig(pool: Pool | null | undefined) {
  let res: any[] = [];

  let getFunctionnalities = (functionnality: string) => {
    return res.find((x) => x.functionnality == functionnality) || null;
  };

  const products: IProduct[] = getPoolProducts(pool);

  for (let i = 0; i < products.length; i++) {
    const pC = getProductByModelIdentifier(products[i].modelIdentifier);

    const functionnalities = pC!.getEventProductFunctionalities();

    if (functionnalities) {
      for (let j = 0; j < functionnalities.length; j++) {
        let res2 = [];

        const cpsConfig: any = pC!.getCPSConfigByFonctionnality(
          functionnalities[j],
        );

        if (cpsConfig && cpsConfig!.historique?.suivi?.graphiques) {
          for (
            let k = 0;
            k < cpsConfig!.historique?.suivi?.graphiques.length;
            k++
          ) {
            res2.push({
              ...cpsConfig!.historique?.suivi?.graphiques[k],
              modelIdentifier: pC?.modelIdentifier,
            });
          }
        }

        if (res2.length > 0) {
          const r = getFunctionnalities(functionnalities[j]);

          if (r === null) {
            res.push({
              functionnality: functionnalities[j],
              graphiques: res2,
            });
          } else {
            r.graphiques.push(...res2);
          }
        }
      }
    }
  }

  return res;
}

export function getPoolProductsAlarm(
  pool: Pool | null | undefined,
): CPSConfigCard[] {
  let res = [];

  const products: IProduct[] = getPoolProducts(pool);

  for (let i = 0; i < products.length; i++) {
    const pC = getProductByModelIdentifier(products[i].modelIdentifier);

    if (pC?.getCPSConfig) {
      const cpsConfig: any = pC.getCPSConfig();

      if (cpsConfig.statusCards) {
        for (let j = 0; j < cpsConfig.statusCards.length; j++) {
          cpsConfig.statusCards[j].productClass = pC;
          res.push(cpsConfig.statusCards[j]);
        }
      }
    }
  }

  return res.sort(weightSort);
}

export function getPoolAlarms(pool: Pool | null | undefined): CPSConfigAlarm[] {
  let res: CPSConfigAlarm[] = [];

  const products: IProduct[] = getPoolProducts(pool);

  for (let i = 0; i < products.length; i++) {
    const pC = getProductByModelIdentifier(products[i].modelIdentifier);

    if (pC?.getCPSConfig) {
      const cpsConfig: any = pC.getCPSConfig();

      if (cpsConfig.alarms) {
        cpsConfig.alarms.productClass = pC;
        res.push(cpsConfig.alarms);
      }
    }
  }

  return res.sort(weightSort);
}

export function getPoolStatusCards(
  pool: Pool | null | undefined,
): CPSConfigCard[] {
  let res = [];

  const products: IProduct[] = getPoolProducts(pool);

  for (let i = 0; i < products.length; i++) {
    const pC = getProductByModelIdentifier(products[i].modelIdentifier);

    if (pC?.getCPSConfig) {
      const cpsConfig: any = pC.getCPSConfig();

      if (cpsConfig.statusCards) {
        for (let j = 0; j < cpsConfig.statusCards.length; j++) {
          cpsConfig.statusCards[j].productClass = pC;
          res.push(cpsConfig.statusCards[j]);
        }
      }
    }
  }

  return res.sort(weightSort);
}

export function getPoolControlCards(
  pool: Pool | null | undefined,
): CPSConfigCard[] {
  let res = [];

  const products: IProduct[] = getPoolProducts(pool);

  for (let i = 0; i < products.length; i++) {
    const pC = getProductByModelIdentifier(products[i].modelIdentifier);
    if (pC?.getCPSConfig) {
      const cpsConfig: any = pC.getCPSConfig();

      if (cpsConfig.controlCards) {
        for (let j = 0; j < cpsConfig.controlCards.length; j++) {
          cpsConfig.controlCards[j].productClass = pC;
          res.push(cpsConfig.controlCards[j]);
        }
      }
    }
  }

  return res.sort(weightSort);
}

export function getPoolMasterClass(
  pool: Pool | null | undefined,
): IMaster | null {
  if (pool && pool.deviceTable) {
    let res = null;
    Object.keys(pool.deviceTable).forEach((key) => {
      if (
        typeof pool!.deviceTable[key] == 'object' &&
        'modelIdentifier' in pool!.deviceTable[key] &&
        isMaster(pool!.deviceTable[key])
      ) {
        res = getProductByModelIdentifier(
          pool!.deviceTable[key].modelIdentifier,
        );
      }
    });

    return res;
  }

  return null;
}

export function getLabelConfigurationWarningModeFromACU(
  pool: Pool | null | undefined,
  versionACU: number,
): LabelConfigurationWarningMode | null {
  const masterACU = getMasterFirmwareVersionFromPool(pool);

  if (masterACU != null) {
    if (masterACU < versionACU) {
      return LabelConfigurationWarningMode.NEED_UPDATE;
    } else if (masterACU === versionACU) {
      return LabelConfigurationWarningMode.NEW;
    }
  }

  return null;
}

export function getMasterFirmwareVersionFromPool(
  pool: Pool | null | undefined,
): number | null {
  const master = getPoolMasterClass(pool);
  return master!.getProductDeviceTableFromPool(pool!).firmwareVersion;
}

export function getPoolProduct(
  pool: Pool | null | undefined,
  productClass: IProduct,
): IProduct | null {
  if (pool && pool.deviceTable) {
    let res = null;
    Object.keys(pool.deviceTable).forEach((key) => {
      if (
        typeof pool!.deviceTable[key] == 'object' &&
        'modelIdentifier' in pool!.deviceTable[key] &&
        pool!.deviceTable[key].modelIdentifier == productClass.modelIdentifier
      ) {
        res = pool!.deviceTable[key];
      }
    });

    return res;
  }

  return null;
}

export function getBrandNameByModelIdentifier(
  modelIdentifier: string | null | undefined,
): string {
  if (modelIdentifier === null || modelIdentifier === undefined) {
    return new EdroBrand().getBrandName();
  }

  let brand = new EdroBrand();
  switch (modelIdentifier) {
    case 'P00039':
      brand = new EdroBrand();
      break;
    case 'P00077':
      brand = new EuropiscineBrand();
      break;
  }

  return brand.getBrandName();
}

export function getBrandKey() {
  const master = getPoolMaster(
    EdroNetworkManager.getInstance().getPoolContext()?.pool,
  );
  return getBrandByModelIdentifier(master?.modelIdentifier).getBrandKey();
}

export function brandOverride(
  text: string | undefined,
  brand: Brand | null = null,
) {
  if (!text) {
    return '';
  }

  const master = getPoolMaster(
    EdroNetworkManager.getInstance().getPoolContext()?.pool,
  );
  const brandName = brand
    ? brand.getBrandName()
    : getBrandNameByModelIdentifier(master?.modelIdentifier);

  if (brandName !== 'e.Dro') {
    return text?.replace('e.Dro', brandName);
  } else {
    return text;
  }
}
